import type { DetailAutomat, ListAutomat, ReportStatus, Bbox } from "../types"

const BASE = import.meta.env.VITE_API_BASE_URL ?? "http://127.0.0.1:8787"

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message)
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
  })
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; message?: string }
    throw new ApiError(res.status, body.error ?? "unknown", body.message ?? `HTTP ${res.status}`)
  }
  return (await res.json()) as T
}

export function listByBbox(b: Bbox): Promise<{ automaty: ListAutomat[] }> {
  const q = b.join(",")
  return request(`/api/automaty?bbox=${encodeURIComponent(q)}`)
}

export function getDetail(id: number): Promise<DetailAutomat> {
  return request(`/api/automaty/${id}`)
}

export function createAutomat(body: {
  lat: number
  lon: number
  chain: string | null
  name?: string | null
}): Promise<{ id: number; merged: boolean; possible_duplicate_of: number | null }> {
  return request("/api/automaty", { method: "POST", body: JSON.stringify(body) })
}

export function reportStatus(
  id: number,
  status: ReportStatus,
): Promise<{ current_status: ReportStatus }> {
  return request(`/api/automaty/${id}/report`, {
    method: "POST",
    body: JSON.stringify({ status }),
  })
}
